import React, { TransitionEvent, useEffect, useState } from 'react';
import { usePHSPACCResultsFeedbackExists } from '@components/phs/pacc/results/query/useFeedback';
import FeedBackSurvey from './feedbackSurvey';
import { FeedBackEndTitle, FeedBackTitle } from './feedbackTitle';
import MoreFeedback from './moreFeedback';
import classNames from 'classnames/bind';
import styles from './feedback.module.scss';

const cx = classNames.bind(styles);

export enum FeedbackStep {
  INIT,
  CLICK_STAR_TRANSITION,
  SHOW_OPTIONS,
  SUBMIT_TRANSITION,
  END,
}

interface FeedbackProps {
  sn: number;
}

const Feedback = ({ sn }: FeedbackProps) => {
  const [step, setStep] = useState<FeedbackStep>(FeedbackStep.INIT);

  const { data: result } = usePHSPACCResultsFeedbackExists(sn);

  useEffect(() => {
    if (result) setStep(FeedbackStep.END);
    else setStep(FeedbackStep.INIT);
  }, [result]);

  const nextStep = (e?: TransitionEvent<HTMLDivElement>) => {
    if (e) e.stopPropagation();
    setStep((prev) => prev + 1);
  };

  return (
    <div className={cx('feedbackArea')}>
      <div
        onTransitionEnd={nextStep}
        className={cx('feedbackInner')}
        style={{ opacity: step === FeedbackStep.SUBMIT_TRANSITION ? 0 : 1 }}
      >
        {step < FeedbackStep.END ? (
          <>
            <FeedBackTitle />
            <FeedBackSurvey sn={sn} step={step} setStep={setStep} nextStep={nextStep} />
          </>
        ) : (
          <>
            <FeedBackEndTitle />
            <MoreFeedback />
          </>
        )}
      </div>
    </div>
  );
};

export default Feedback;
